import { IconProps } from '../constants'
import SVGContainer from './svg-container'

const ChevronLeft = (props: IconProps) => (
  <SVGContainer {...props}>
    <path
      d='M15 19L8 12L15 5'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </SVGContainer>
)

export default ChevronLeft
